import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, LinearProgress } from '@material-ui/core';

import axios from 'axios';
import { oembed } from '@loomhq/loom-embed';
import { storeContext } from '../provider/Provider';

import { campaignUpdatesActions } from '../../store/campaign-updates-reducer';
import VideoItem from './VideoItem';

const { REACT_APP_FLASK_API_URL } = process.env;

const useStyles = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  wrapper: {
    margin: 50,
    [theme.breakpoints.down('sm')]: {
      margin: '0 5px',
    },
  },
  header: {
    fontFamily: 'Roboto',
    fontWeight: 900,
    fontSize: 50,
    color: '#58595B',
  },
  thin: {
    fontFamily: 'Roboto',
    fontWeight: 300,
    fontSize: 40,
  },
}));

const CampaignUpdates = () => {
  const { state, dispatch } = useContext(storeContext);
  const classes = useStyles();
  const { message_id: openMessageId } = useParams();

  const getMessages = () => {
    // if (!state.campaignUpdates.messages?.length) {
      dispatch({
        type: campaignUpdatesActions.CAMPAIGN_UPDATES_SET_ALL,
        payload: { isFetching: true },
      });
    // }

    axios
      .get(`${REACT_APP_FLASK_API_URL}/v1/loom/${state.websiteSwitch.currentWebsite}`)
      .then(async (res) => {
        if (!res.data.error) {
          const notSeenMessages = res.data.data.messages.filter(
            (message) => !message.is_seen_by_client
          );
          if (notSeenMessages?.length) {
            axios.post(
              `${REACT_APP_FLASK_API_URL}/v1/loom/mark-seen/${state.websiteSwitch.currentWebsite}`,
              {
                message_ids: notSeenMessages.map((message) => message.message_id),
              }
            );
          }
          const messages = await Promise.all(
            res.data.data.messages
              // .sort(a => a.star ? -1 : 1)
              .map(async (message) => {
                let embed = '';
                let thumbnail = '';
                let embedId = '';
                if (message.loom_url.indexOf('/embed/') === -1) {
                  try {
                    const loomObj = await oembed(message.loom_url);
                    embed = loomObj.html;
                    embedId = embed.replace(/.*?\/embed\/([a-z0-9]*).*/, '$1');
                    thumbnail = loomObj.thumbnail_url;
                  } catch (e) {
                    // console.log(e);
                  }
                }
                return {
                  ...message,
                  embed,
                  embedId,
                  thumbnail,
                };
              })
          );

          dispatch({
            type: campaignUpdatesActions.CAMPAIGN_UPDATES_SET_ALL,
            payload: {
              isFetching: false,
              messages,
              newMessagesCount: 0,
            },
          });
        }
      })
      .catch();
  };

  const updateLocalMessages = (updatedMessage) => {
    dispatch({
      type: campaignUpdatesActions.CAMPAIGN_UPDATES_SET_ALL,
      payload: {
        messages: state.campaignUpdates.messages.map((message) =>
          updatedMessage.message_id === message.message_id ? updatedMessage : message
        ),
      },
    });
  };

  useEffect(getMessages, []);

  if (state.campaignUpdates.isFetching) {
    return <LinearProgress style={{ width: '100%' }} />;
  }

  return (
    <div className={classes.wrapper}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <h1 className={classes.header}>
            What&apos;s New | <span className={classes.thin}>Website Performance Updates</span>
          </h1>
        </Grid>
      </Grid>
      {state.campaignUpdates.messages.length === 0 && <Box width="100%" py={3}>
        <Box component='h3' style={{color: '#58595B', height: '70px'}}>No videos were recorded yet for {state.websiteSwitch.currentWebsite}.</Box>
      </Box>}
      <Grid container spacing={6}>
        {state.campaignUpdates.messages
          ? state.campaignUpdates.messages
              .filter((message) => message.star)
              .map((message) => (
                <Grid
                  // style={{display: message.thumbnail ? 'block' : 'none'}}
                  key={message.message_id}
                  item
                  xs={12}
                  md={4}
                  lg={3}
                >
                  <VideoItem
                    updateCallback={updateLocalMessages}
                    params={{
                      ...message,
                      open: parseInt(openMessageId, 10) === parseInt(message.message_id, 10),
                    }}
                  />
                </Grid>
              ))
          : ''}
      </Grid>
      <Grid container spacing={6}>
        {state.campaignUpdates.messages
          ? state.campaignUpdates.messages
              .filter((message) => !message.star)
              .map((message) => (
                <Grid
                  // style={{display: message.thumbnail ? 'block' : 'none'}}
                  key={message.message_id}
                  item
                  xs={12}
                  md={4}
                  lg={3}
                >
                  <VideoItem
                    updateCallback={updateLocalMessages}
                    params={{
                      ...message,
                      open: parseInt(openMessageId, 10) === parseInt(message.message_id, 10),
                    }}
                  />
                </Grid>
              ))
          : ''}
      </Grid>
    </div>
  );
};

export default CampaignUpdates;
